import React, { useContext, useEffect, useState } from 'react';
import { AccountContext } from '../../../components/AccountContext';
import { Loading } from '../../../components/Loading';
import { growlErrors } from '../../../utils/NotificationUtil';
import { useQuery } from '@apollo/react-hooks';
import { NotificationContext } from '../../../components/GrowlNotifications';
import { CONFIG_QUERY } from './services/super--profiles.service';
import { Panel } from 'primereact/panel';
import { Formik } from 'formik';
import { defineMessages, useIntl } from 'react-intl';
import useSuperProfile from './hooks/useSuperProfile';
import {
  buildSuperProfileFormInitialValues,
  buildSuperProfileFormValidationSchema,
} from './helpers/super-profiles.helper';
import SuperProfileForm from './components/SuperProfileForm';

const messages = defineMessages({
  header: {
    id: 'account.super-profiles.new.header',
    defaultMessage: 'New SuperProfile',
  },
});

const AddSuperProfile = () => {
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);
  const { formatMessage } = useIntl();

  const [jobProfiles, setJobProfiles] = useState([]);
  const [availableCountries, setAvailableCountries] = useState([]);
  const [availableLanguages, setAvailableLanguages] = useState([]);

  const { handleAddSuperProfile } = useSuperProfile();

  const { loading, error, data } = useQuery(CONFIG_QUERY, {
    variables: {
      accountId: currentAccount,
    },
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (data && data.account && data.availableCountries && data.activeLocales) {
      const { availableCountries: countries, activeLocales, account } = data;

      setJobProfiles(account.greatFullSpectrumJobProfiles);
      setAvailableCountries(countries);
      setAvailableLanguages(activeLocales);
    }
    // eslint-disable-next-line
  }, [data]);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    growlErrors(growl, error);
  }

  const initialValues = buildSuperProfileFormInitialValues();
  const validationSchema = buildSuperProfileFormValidationSchema();

  return (
    <div className="brand-detailed-wrapper">
      <Panel header={formatMessage(messages.header)}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleAddSuperProfile(values);
          }}
        >
          <SuperProfileForm
            jobProfiles={jobProfiles}
            availableCountries={availableCountries}
            availableLanguages={availableLanguages}
          />
        </Formik>
      </Panel>
    </div>
  );
};

export default AddSuperProfile;
